<template>

  <div class="container" >
  <b-code>
    <!-- button  v-if="folders.length === 0" -->
    <div class="card">
      <div class="card-body">
        <div class="flex align-items-center justify-content-end">
          <p class="h3 text-success fw-bold  float-end">
            <b-button class="float-end" id="toggle-btn" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-modal.modal-prevent-closing variant="outline-primary">
              <feather-icon icon="FolderPlusIcon" />
              Criar Pastas
            </b-button>
          </p>
        </div>
      </div>
    </div>
<!-- 
      <b-button class="float-end" id="toggle-btn" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-modal.modal-prevent-closing variant="outline-primary">
        <feather-icon icon="FolderPlusIcon" />
        Criar Pastas
      </b-button> -->

      <!-- modal data -->
      <!-- <div class="mt-2">
    <div v-if="submittedNames.length === 0">
     
    </div>
    <b-list-group
      v-else
    >
      <b-list-group-item
        v-for="(data,index) in submittedNames"
        :key="index"
      >
        {{ data }}
      </b-list-group-item>
    </b-list-group>
  </div> -->

      <!-- modal -->
      <b-modal id="modal-prevent-closing" ref="my-modal" title="Nova pasta" ok-title="Criar Pasta"
        cancel-title="Cancelar" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="CriarPasta">
          <b-form-group :state="nameState" label="Nome da pasta" label-for="name-input"
            invalid-feedback="Esse campo é obrigatório">
            <b-form-input id="name-input" v-model="pastaAws.folder_name" :state="nameState"
              placeholder="Digite o nome da pasta" required />
          </b-form-group>
        </form>
      </b-modal>

      <template #code>
        {{ codePrevent }}
      </template>
      <template>
        <div class="container ">
          <div class="card cardhover" v-for="item of folders" :key="item">
            <div class="card-body">
              <div class="row">
                <div class="col-1  align-self-center">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="check1" name="option1" value="something"
                      checked>
                  </div>
                </div>
                <div class="col-1 align-self-center  ">
                  <div class="folder-thumb-name--folder___3VtKS">
                    <span role="img" aria-label="folder" class="anticon anticon-folder">
                      <svg viewBox="64 64 896 896" focusable="false" data-icon="folder" width="1em" height="1em"
                        fill="currentColor" aria-hidden="true">
                        <path
                          d="M880 298.4H521L403.7 186.2a8.15 8.15 0 00-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z">
                        </path>
                      </svg>
                    </span>
                  </div>
                </div>
                <div class="col align-self-center">
                  <div class="folder-thumb-name--info___hpPoo">
                    <div class="player-card-name___28G2g">
                      <strong>{{ item.folder_name }}</strong>
                      <span role="img" aria-label="edit" tabindex="-1"
                        class="anticon anticon-edit player-card-name--edit_icon___3cbkf">
                        <button @click="deleteFolder()" class="btn ">
                          <feather-icon icon="Edit3Icon" />
                        </button>
                      </span>
                    </div>
                    <span class="info_createAt___3RamW">{{ item.folder_date }}</span>
                  </div>
                </div>

                <div class="col-1 align-self-center ">
                  <el-dropdown>
                    <el-button type="button">
                      <i class="el-icon-more"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">

                      <el-dropdown-item>
                        <feather-icon icon="TrashIcon" size="18" stroke="blue" class="mr-50" /><span
                          @click="open(item)">Remover</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>


                  <!-- <button @click="deleteFolder(item.id)" class="btn ">
                 <feather-icon icon="MoreHorizontalIcon"  stroke="red"/>
            </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>

    </b-code>
  </div>


</template>

<script>
import axios from "axios";

import {
  BButton, BFormGroup, BFormInput, BModal, VBModal, BCardText, BListGroup, BListGroupItem, BAlert, BLink, BCard
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import Ripple from 'vue-ripple-directive'
import { codePrevent } from '@/views/App/Pastas/code copy'
import { FolderService } from '@/services/Folder'
import FoldersVue from './Folders.vue'
export default {
  components: {
    BCardCode,
    BButton,
    BFormGroup,
    BCardText,
    BFormInput,
    BListGroup,
    BListGroupItem,
    BModal,
    BAlert,
    BLink,
    BCard


  },
  directives: {
    'b-modal': VBModal,

    Ripple,
  },
  name: "Modal",

  data: function () {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      VUE_APP_HOST_API_AWS_S3: process.env.VUE_APP_HOST_API_AWS_S3 || '/api/dkbucket',
      contentWidth: this.$store.state.appConfig.layout.contentWidth,
      userData: JSON.parse(localStorage.getItem('userData')),
      loading: false,
      folders: [],
      errorMessage: null,
      codePrevent,
      // folder: {
      //   folder_name: '',
      //   id_user: '',
      // },

      pastaAws: {
        folder_name: '',
      },

      nameState: null,
      folders: [],

    }
  },


  created: async function () {
    try {
      this.loading = true;
      let response = await FolderService.getALLFolders()
      this.folders = response.data;
      this.loading = false;
      // console.log('folders');
      // console.log(this.folders)

    }
    catch (error) {
      this.errorMessage = error;
      this.loading = false;
    }

  },
  mounted() {
    this.listar()
  },
  methods: {
    listar() {
      FolderService.getALLFolders().then(resposta => {
        this.folders = resposta.data
      }).catch(e => {
        console.log(e)
      })
    },
    deleteFolder: function (folderId) {
      try {
        this.loading = true;
        FolderService.deleteFolder(folderId).then(response => {
          if (response) {
            FolderService.getALLFolders().then(response => {
              this.folders = response.data;
              this.loading = false;
            });

          }

        });

      }
      catch (error) {
        this.errorMessage = error;
        this.loading = false;
      }
    },

    deletarPastaAWS: function (item) {


      const options = {
        method: 'DELETE',
        url: `${this.VUE_APP_HOST_API_AWS_S3}/`,
        params: {
          key: item.folder_key_name,
        }
      };

      axios.request(options).then(function (response) {
      }).catch(function (error) {
        console.error(error);
      });
    },

    open: function (item) {
      this.$confirm('Você tem certeza que deseja deletar a pasta? Se sim, todos os dados e arquivos serão removidos.', 'Deletar Pasta', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'Deletar pasta'
      }).then((res) => {
        if (res) {
          // console.log('respt');
          // console.log(res);
          this.deletarPastaAWS(item);
          this.deleteFolder(item.id);
        }
        this.$message({
          type: 'success',
          message: 'Deletado com sucesso'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete cancelado'
        });
      });
    },
   
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.name = valid
      return valid
    },
    resetModal() {
      this.pastaAws.folder_name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.CriarPasta()
    },
    handleSubmit() {


      fetch(`${this.VUE_APP_HOST_API_BACKEND}/folder`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{"folder_name":"' + this.pastaAws.folder_name.replace(/(\r\n|\n|\r)/gm, "") +
          '","folder_backet_adress":"' + this.Url_pasta +
          '","folder_key_name":"' + this.key_name +
          '","id_user":"' + this.userData.id + '"}'
      })
        .then(response => {

          this.$notify({
            title: 'Success',
            message: 'Pasta criada com sucesso.',
            type: 'success'
          });


          //  window.location.replace("http://localhost:8080/videos");
        })
        .catch(err => console.error(err));
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      // Push the name to submitted names
      this.folders.push(this.folder)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn')
      })
    },

    async CriarPasta() {
      if (!this.pastaAws.folder_name || !this.pastaAws.folder_name.trim()) return

      // Tenta criar pasta no S3 (opcional — falha silenciosamente)
      this.Url_pasta = ''
      this.key_name = `UploadFolderVideos/${this.pastaAws.folder_name}/`

      try {
        const s3Res = await fetch(
          `${this.VUE_APP_HOST_API_AWS_S3}/create?caminho=UploadFolderVideos/${encodeURIComponent(this.pastaAws.folder_name)}/`,
          { method: 'POST' },
        )
        if (s3Res.ok) {
          const contentType = s3Res.headers.get('content-type') || ''
          if (contentType.includes('application/json')) {
            const s3Data = await s3Res.json()
            this.Url_pasta = s3Data.fileUrl || ''
            this.key_name = s3Data.file_key || this.key_name
          }
        }
      } catch (_s3Err) {
        // S3 não configurado — continua sem URL de bucket
      }

      // Sempre salva no banco de dados, independente do S3
      this.handleSubmit()
      this.listar()
    },
    // handleSubmit (){
    //   fetch('http://localhost:3030/folder', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    //     body: '{"folder_name":"' + this.folder.folder_name + 
    //     '","id_user":"' + this.userData.id + '"}'

    //   })
    //   .then(response => {
    //     window.location.replace("http://localhost:8080/videos");
    //   })



    //     .catch(err => console.error(err));
    //   // Exit when the form isn't valid
    //   if (!this.checkFormValidity()) {
    //     return
    //   }

    //   // Push the name to submitted names
    //   this.folders.push(this.folder)
    //   // Hide the modal manually
    //   this.$nextTick(() => {
    //     this.$refs['my-modal'].toggle('#toggle-btn')
    //   })
    // },
  },
}
</script>
<style>
.folder-thumb-name--folder___3VtKS {
  font-size: 3rem;
  color: #7367f0;
}
</style>